import { useRef } from 'react';
import classNames from 'classnames';

import { MeatballsIcon } from '../../icons';
import OverlayPopover from '../OverlayPopover';

import styles from './_index.module.scss';

export interface ActionOverlayPopoverProps {
  children: React.ReactNode;
  hasArrow?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
  onHide?: () => void;
}

const ActionOverlayPopover = ({
  children,
  hasArrow,
  isActive,
  isDisabled,
  onClick = () => {},
  onHide,
}: ActionOverlayPopoverProps) => {
  const popoverRef = useRef<HTMLDivElement>(null);

  return (
    <div className={styles['action-overlay-popover']}>
      <div
        className={classNames(styles['action-overlay-popover-ellipsis'], {
          [styles['is-active']]: isActive,
          [styles['is-disabled']]: isDisabled,
        })}
        data-testid="action-overlay-popover-icon"
        onClick={isDisabled ? () => {} : onClick}
        ref={popoverRef}
      >
        <MeatballsIcon />
      </div>
      {isActive && (
        <OverlayPopover
          hasArrow={hasArrow}
          isActive={isActive}
          onHide={onHide}
          target={popoverRef?.current}
        >
          {children}
        </OverlayPopover>
      )}
    </div>
  );
};

export default ActionOverlayPopover;
